import * as React from 'react';

import { useQuery } from '@apollo/client';

import { MyRecentActivityBaseComponent } from 'bundles/enterprise-legacy-learner-home/components/single-program/MyRecentActivity';
import { toOrgHomeTab } from 'bundles/enterprise-legacy-learner-home/links';
import ProgramCurriculumLatestEnrolledCoursesForOrg from 'bundles/enterprise-legacy-learner-home/queries/ProgramCurriculumLatestEnrolledCoursesForOrgQuery';
import type {
  ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQuery,
  ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQueryVariables,
} from 'bundles/naptimejs/resources/__generated__/ProgramCurriculumProductsV1';
// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import ProgramCurriculumProductsV1 from 'bundles/naptimejs/resources/programCurriculumProducts.v1';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { TabName } from 'bundles/program-home/components/enterprise-home/EnterpriseHomeTabs';

type PropsFromCaller = {
  userId: number;
  thirdPartyOrganizationId: string;
  thirdPartyOrgSlug: string;
};

const MyRecentActivityForMultiProgram: React.FC<PropsFromCaller> = ({
  userId,
  thirdPartyOrgSlug,
  thirdPartyOrganizationId,
}) => {
  const { data, loading } = useQuery<
    ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQuery,
    ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserQueryVariables
  >(ProgramCurriculumLatestEnrolledCoursesForOrg, {
    variables: {
      thirdPartyOrganizationId,
      userId: userId.toString(),
    },
  });

  const product =
    data?.ProgramCurriculumProductsV1?.latestEnrolledCourseActivitiesByThirdPartyOrganizationAndUser?.elements?.[0];
  const inProgressCourse = product && new ProgramCurriculumProductsV1(product);
  const programId = product?.programId;
  const viewMyCoursesUrl = toOrgHomeTab(thirdPartyOrgSlug, TabName.MyCourses);

  return (
    <MyRecentActivityBaseComponent
      programId={programId}
      thirdPartyOrganizationId={thirdPartyOrganizationId}
      viewMyCoursesUrl={viewMyCoursesUrl}
      userId={userId}
      inProgressCourse={inProgressCourse}
      loading={loading}
    />
  );
};

export default MyRecentActivityForMultiProgram;
